/* eslint-disable camelcase */
import axios from 'axios'
import { useCallback, useEffect, useRef, useState } from 'react'
import { LyricsData } from 'player'
import { config } from '../../../config'

interface LyricsOperation {
  start(start: any): void
  end: any
  id?: any
  text?: string
  word: string
  // TODO This is not in milliseconds
  fromMs: string
  // TODO This is not in milliseconds
  toMs: string
  active?: string
  inLoop: boolean
}

interface UseFetchLyrics {
  loading: boolean
  languages: LyricsData['availableLanguages']
  error: boolean
  lyrics: LyricsOperation[]
}

export const useFetchLyrics = (
  url?: string,
  userGeneratedLyrics?: any[]
): UseFetchLyrics => {
  const [lyrics, setLyrics] = useState<LyricsOperation[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const defined: any = useRef(false)

  const fetchLyrics = useCallback(async (lyricsUrl: string) => {
    try {
      setLoading(true)
      let { data }: any = await axios.get(
        `${config.api.endpoint}/v3/download${lyricsUrl}`
      )

      if (typeof data === 'string') data = JSON.parse(data)

      if (!defined.current) {
        setLyrics(data)
      }

      setLoading(false)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
      setError(true)
      setLoading(false)
    }
  }, [])

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    defined.current = userGeneratedLyrics && userGeneratedLyrics.length > 0

    if (userGeneratedLyrics && userGeneratedLyrics.length > 0) {
      setLyrics(userGeneratedLyrics)
      return
    }
    if (url) {
      fetchLyrics(url)
    }
  }, [fetchLyrics, url, userGeneratedLyrics])

  return {
    lyrics,
    languages: [],
    error,
    loading
  }
}
